module.exports = __webpack_public_path__ + "static/media/环境减灾一号C星.5e91f4fd.png";